/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Jomon's Portfolio",
  description:
    "M.Sc. Computer Science, UPB | Program Analyst",
  og: {
    title: "Jomon George Portfolio",
    type: "website",
    url: "https://jomongeorge.com/",
  },
};

//Home Page
const greeting = {
  title: "Jomon George",
  logo_name: "JomonGeorge",
  nickname: "",
  subTitle:
    "M.Sc. Computer Science, UPB",
  resumeLink:
    "https://drive.google.com/file/d/1pa9X243VGNomNm7uK0R3wVuMZ-IkxwFv/view?usp=sharing.google.com/file/d/1FL_wydnPF2SWCdw2goYAgZ1KKBx8TpcD/view?usp=sharing",
  portfolio_repository: "https://github.com/jmngeo/jmngeo.github.io",
  githubProfile: "https://github.com/jmngeo",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/jmngeo",
  // linkedin: "https://www.linkedin.com/in/jmngeo/",
  // gmail: "@gmail.com",
  // gitlab: "https://gitlab.com/jmngeo",
  // facebook: "https://www.facebook.com/",
  // twitter: "https://twitter.com/",
  // instagram: "https://www.instagram.com/"

  {
    name: "Github",
    link: "https://github.com/jmngeo",
    fontAwesomeIcon: "fab fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/jmngeo/",
    fontAwesomeIcon: "fab fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Mail",
    link: "mailto:jmngeo@protonmail.com",
    fontAwesomeIcon: "far fa-paper-plane", // Reference https://fontawesome.com/icons/paper-plane?style=regular
    backgroundColor: "#05505E",
  },
];

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "BuildingWebsitesImg",
      skills: [
        "⚡ Building responsive web frontends using Vue 3 with Pinia state management and component libraries",
        "⚡ Developing REST API backends with Flask and PostgreSQL",
        "⚡ Integrating LLMs and AI pipelines using LangChain and OpenAI APIs",
        "⚡ Containerizing and deploying applications with Docker and Nginx",
      ],
      softwareSkills: [
        {
          skillName: "Vue.js",
          fontAwesomeClassname: "simple-icons:vuedotjs",
          style: {
            color: "#4FC08D",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#4169E1",
          },
        },
        {
          skillName: "OpenAI",
          fontAwesomeClassname: "simple-icons:openai",
          style: {
            color: "#412991",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#2496ED",
          },
        },
        {
          skillName: "Nginx",
          fontAwesomeClassname: "simple-icons:nginx",
          style: {
            color: "#009639",
          },
        },
        {
          skillName: "Vite",
          fontAwesomeClassname: "simple-icons:vite",
          style: {
            color: "#646CFF",
          },
        },
      ],
    },
    {
      title: "Automation Testing & Software QA",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Testing and support of RCP and HIL software products",
        "⚡ Development of REST API plugins using Python and C#",
        "⚡ Writing automation scripts for integration testing using Selenium and Java",
        "⚡ Test analysis, reporting, and CI/CD pipeline integration with Jenkins",
      ],
      softwareSkills: [
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "C#",
          fontAwesomeClassname: "devicon:csharp",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "devicon:java",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Selenium",
          fontAwesomeClassname: "simple-icons:selenium",
          style: {
            color: "#43B02A",
          },
        },
        {
          skillName: "Apache Maven",
          fontAwesomeClassname: "simple-icons:apachemaven",
          style: {
            color: "#C71A36",
          },
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "simple-icons:jenkins",
          style: {
            color: "#D24939",
          },
        },
      ],
    },
    {
      title: "Agentic AI Exploration",
      fileName: "AiCodeGenerationImg",
      skills: [
        "⚡ Exploring AI agent frameworks and tool-use patterns",
        "⚡ Building simple agentic pipelines using LangChain and OpenAI APIs",
        "⚡ Learning prompt engineering and structured output techniques",
      ],
      softwareSkills: [
        {
          skillName: "OpenAI",
          fontAwesomeClassname: "simple-icons:openai",
          style: {
            color: "#412991",
          },
        },
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: {
            color: "#1C3C3C",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Game Development",
      fileName: "OuterSpaceImg",
      skills: [
        "⚡ Serious Game development using Unity and C#",
        "⚡ Online Multiplayer game development using Photon",
      ],
      softwareSkills: [
        {
          skillName: "Unity",
          fontAwesomeClassname: "iconoir:unity",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "C#",
          fontAwesomeClassname: "devicon:csharp",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Unreal Engine",
          fontAwesomeClassname: "fontisto:unreal-engine",
          style: {
            backgroundColor: "transparent",
          },
        },
      ],
    },

  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
  ],
};

const degrees = {
  degrees: [
    {
      title: "Paderborn University, Germany",
      subtitle: "Master's in Computer Science",
      logo_path: "upb_logo.png",
      alt_name: "Uni Paderborn",
      duration: "2021 - 2026",
      descriptions: [
        "⚡ Specialization in Software Engineering: Model-Based Systems Engineering, Data-Driven Innovation, and Secure Systems",
        "⚡ Studied Planning and Heuristic Search, Computational Argumentation, and Data Science in Industrial Applications",
        "⚡ Master's Project: Serious Game development using Unity and C#",
        "⚡ Master's Thesis: GenAI-based prototype for Systems Engineering Qualification Planning",
      ],
      website_link: "https://www.uni-paderborn.de/en/university/",
    },
    {
      title: "Model Engineering College, India",
      subtitle: "B.Tech. in Computer Science and Engineering",
      logo_path: "mec_logo.png",
      alt_name: "MEC",
      duration: "2015 - 2019",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like Data Structres, Algorithms, DBMS, OS, AI, etc.",
        "⚡ As part of Final Year project, I have worked on Video anomaly detection using image processing techniques and a detailed comparison with ROC curves of the following Classifiers: KNN, RBF-SVM, Naive Bayes, AdaBoost, Decision Tree, Random Forest, and Neural Networks.",
      ],
      website_link: "https://www.mec.ac.in",
    },
  ],
};

const certifications = {
  certifications: [
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "",
  description:
    "I have professional experience in software testing and development across enterprise softwares, and web applications — spanning roles in Germany and India.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Working Student",
          company: "dSPACE SE & Co. KG",
          company_url: "https://www.dspace.de/",
          logo_path: "dSPACE_Logo.png",
          duration: "August 2023 - August 2026",
          location: "Paderborn, Germany",
          description: [
            "⚡ Testing and Support of RCP, HIL Software Products",
            "⚡ Development of REST API Plugins with Python and C#",
            "⚡ Test Analysis and Reports",
          ],
          color: "#0879bf",
        },
        {
          title: "Program Analyst",
          company: "Cognizant Technology Solutions",
          company_url: "https://www.cognizant.com/",
          logo_path: "CognizantLogo.png",
          duration: "December 2019 - April 2021",
          location: "Coimbatore, Tamil Nadu",
          description: [
            "⚡ Involving in Testing and Support of Insurance Software Products\n",
            "⚡ Involving in the design of end to end test cases - Script/ Scenario creation",
            "⚡ Developing automation scripts for integration testing using Selenium, TestNG, Maven, and Webdriver",
            "⚡ Test Execution and production support",
            "⚡ Delivering business demos",
            "⚡ Developing error validation scripts",
            "⚡ Validating APIs using Postman",
            "⚡ Test Analysis and test report",
            "⚡ Test report logs and summary",
          ],
          color: "#0879bf",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Developer Intern",
          company: "Actionfi technologies",
          company_url: "https://www.actionfi.com/",
          logo_path: "ActionfiLogo.png",
          duration: "June 2018 - July 2018",
          location: "Kozhikode, Kerala",
          description: [
            "⚡ Developing Customer Service Chatbot Application - chatbox extension through which the user communicates in real-time with the service agent using SAP tools (SAP UI5), Firebase, and Javascript.",
            "⚡ Developing an administrator chat window for the service agent.",
          ],
          color: "#7399c6",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "A collection of projects spanning full stack web development, automation testing, and game development. Built using technologies like Vue, Flask, Python, C#, and Unity.",
  avatar_image_path: "portfolio-website.svg",
};


export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
};
